import { motion } from "framer-motion";
import { useState } from "react";
import Images from "../../utils/Images";

export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setIsSubscribed(true);
      setEmail("");
      // Here you would typically send the email to your backend
      console.log("Subscribing email:", email);
    }
  };

  return (
    <section className="relative py-16 mt-16 bg-black sm:mt-24 lg:mt-32 sm:py-20">
      {/* Dotted background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(255,255,255,0.12)_1px,transparent_1px)] [background-size:16px_16px]" />

      {/* Decorative arcs */}
      <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full border-8 pointer-events-none border-emerald-600/40" />
      <div className="absolute bottom-10 -right-20 w-64 h-64 rounded-full border-8 pointer-events-none border-emerald-600/30" />

      <div className="grid relative grid-cols-1 gap-10 px-4 mx-auto max-w-7xl sm:px-6 lg:grid-cols-3 lg:items-center lg:gap-12 lg:px-8">
        {/* Copy */}
        <div className="col-span-2 max-w-2xl">
          <motion.h2
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="mb-3 text-3xl font-extrabold leading-tight text-white sm:text-4xl lg:text-5xl"
          >
            Insure and secure your trip
            <span className="block text-[#22C55E]">*380*0000#</span>
            <span className="block text-[#22C55E]">
              and choose your cover in seconds
            </span>
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1, duration: 0.5 }}
            className="mb-8 max-w-lg text-sm leading-relaxed text-gray-300 sm:text-base lg:max-w-lg"
          >
            Stay updated with essential travel info, exclusive insurance deals,
            and the latest policy changes delivered straight to you.
          </motion.p>

          {/* Form */}
          {!isSubscribed ? (
            <motion.form
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.5 }}
              onSubmit={handleSubmit}
              className="flex gap-3 items-center p-2 w-full max-w-xl rounded-xl ring-1 backdrop-blur bg-white/5 ring-white/10"
            >
              <input
                type="tel"
                inputMode="tel"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your phone number"
                required
                className="flex-1 px-4 w-full h-12 text-white bg-transparent rounded-lg placeholder:text-gray-400 focus:outline-none"
              />
              <button
                type="submit"
                className="inline-flex justify-center items-center px-6 h-12 font-semibold text-black bg-emerald-600 rounded-lg transition shrink-0 hover:bg-emerald-500"
              >
                Submit
              </button>
            </motion.form>
          ) : (
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              className="inline-flex items-center px-6 py-3 space-x-2 text-emerald-800 bg-emerald-100 rounded-full"
            >
              <span className="font-medium">
                Successfully subscribed! Check your email for confirmation.
              </span>
            </motion.div>
          )}

          {/* Privacy Note */}
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3, duration: 0.5 }}
            className="mt-4 text-xs text-gray-400"
          >
            We respect your privacy. Unsubscribe at any time.
          </motion.p>
        </div>

        {/* Phone visual */}
        <motion.div
          initial={{ opacity: 0, y: 20, rotate: 8 }}
          whileInView={{ opacity: 1, y: 0, rotate: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative z-10 mx-auto w-full max-w-sm lg:absolute lg:-right-6 lg:-top-32 lg:max-w-lg xl:-right-8 xl:-top-48 xl:max-w-xl 2xl:-top-56 2xl:max-w-xl"
        >
          <img
            src={Images.phone_cta}
            alt="Phone CTA"
            className="mx-auto w-[88%] -rotate-3 transform-gpu origin-bottom scale-y-[1.08] drop-shadow-[0_25px_40px_rgba(34,197,94,0.25)] sm:w-[86%] lg:w-[90%] xl:w-[85%] 2xl:w-[80%]"
          />
        </motion.div>
      </div>
    </section>
  );
}
